import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {COLOR_HIGHLIGHT} from '@gongxigames/framework/slotV2/ui/ui-koala/CONSTANTS';

export const uiTickerStore = Store.createStore({
    text: Store.signal(''),
    isDifferentColorPossible: Store.signal(false),
    color: Store.signal(COLOR_HIGHLIGHT),
    // TODO think about removing of this internal state
    uiTicker_isFreeSpinsState: Store.signal(false),
    idleTimerDelay: Store.signal(10000),
});